import React, { Component } from 'react';

import _ from 'lodash';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import { DateUtils } from 'react-day-picker';
// import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';
import cn from 'classnames';

const formatMultipleDate = 'DD/MM/YYYY';

export default class MultipleDatePicker extends Component {
  constructor(props) {
    super(props);
    const selectedDaysString = _.sortBy(props.selectedDays).map((date) => moment(date).format(formatMultipleDate));
    this.state = {
      selectedDaysString,
    };
  }

  handleDayClick = (day, { selected }, event) => {
    const { selectedDays } = this.props;
    if (selected) {
      const selectedIndex = selectedDays.findIndex((selectedDay) => DateUtils.isSameDay(selectedDay, day));
      selectedDays.splice(selectedIndex, 1);
    } else {
      selectedDays.push(day);
    }
    const sortedSelectedDays = _.sortBy(selectedDays);

    const selectedDaysString = sortedSelectedDays.map((date) => moment(date).format(formatMultipleDate));
    this.setState({ selectedDays: sortedSelectedDays, selectedDaysString: selectedDaysString.join(', ') });
    this.props.onChange([...sortedSelectedDays]);
  };

  render() {
    return (
      <div className={cn({ 'has-error': !!this.props.error })}>
        <DayPicker
          style={{ width: `${(this.props.width || '100').replace(/%/g, '')}%`, display: this.props.displayStyle || 'block' }}
          onDayChange={this.handleDayClick}
          selectedDays={this.props.selectedDays}
          disabledDays={[
            {
              after: this.props.maxDate.toDate() || null,
              before: this.props.minDate.toDate() || null,
            },
          ]}
          onDayClick={this.handleDayClick}
          locale="th"
          localeUtils={MomentLocaleUtils}
          value={this.state.selectedDaysString}
          hideOnDayClick={false}
          onMonthChange={this.props.onMonthChange}
          modifiers={this.props.modifiers}
        />

        {this.props.error && <span className="help-block">{this.props.error}</span>}
      </div>
    );
  }
}
